import { isSamePlatformId } from '@app/modules/social-export/domain/is-same-platform-id';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { Box } from '@mui/material';

import { PublishPlatformBarItem } from './PublishPlatformBarItem';

export interface PublishPlatformBarProps {
  /** Platforms the user can open the upload wizard for. */
  platforms: SocialPlatform[];
  /** Called with the platform id when the user picks an entry. */
  onSelectPlatform: (platformId: string) => void;
  /** When true, all tiles stay disabled (e.g. no renderable media sources). */
  disabled?: boolean;
  /** Highlights the active platform (in-page switcher). */
  selectedPlatformId?: string;
}

/**
 * Icon bar for choosing a social platform (publish tab / upload switcher).
 */
export function PublishPlatformBar({
  platforms,
  onSelectPlatform,
  disabled = false,
  selectedPlatformId,
}: PublishPlatformBarProps) {
  if (platforms.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1,
        alignItems: 'stretch',
      }}
    >
      {platforms.map((platform) => (
        <PublishPlatformBarItem
          key={platform.id}
          platform={platform}
          selected={selectedPlatformId != null && isSamePlatformId(platform.id, selectedPlatformId)}
          disabled={disabled}
          onSelect={() => onSelectPlatform(platform.id)}
        />
      ))}
    </Box>
  );
}
